import React from "react";

function ArrowleftIcon() {
  return (
    <svg className="navigation-direction-icon"
      width="13"
      height="10"
      viewBox="0 0 13 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.27934 1.29871C5.35303 1.23005 5.41213 1.14725 5.45312 1.05525C5.49411 0.963247 5.51616 0.863934 5.51793 0.763231C5.51971 0.662528 5.50118 0.562499 5.46346 0.46911C5.42574 0.375722 5.3696 0.290888 5.29838 0.21967C5.22716 0.148451 5.14233 0.0923064 5.04894 0.0545854C4.95555 0.0168643 4.85552 -0.00166006 4.75482 0.000116722C4.65412 0.00189351 4.5548 0.023935 4.4628 0.064927C4.3708 0.105919 4.288 0.165021 4.21934 0.238708L0.21934 4.23871C0.0788894 4.37933 0 4.56996 0 4.76871C0 4.96746 0.0788894 5.15808 0.21934 5.29871L4.21934 9.29871C4.288 9.3724 4.3708 9.4315 4.4628 9.47249C4.5548 9.51348 4.65412 9.53552 4.75482 9.5373C4.85552 9.53908 4.95555 9.52055 5.04894 9.48283C5.14233 9.44511 5.22716 9.38896 5.29838 9.31775C5.3696 9.24653 5.42574 9.16169 5.46346 9.06831C5.50118 8.97492 5.51971 8.87489 5.51793 8.77419C5.51616 8.67348 5.49411 8.57417 5.45312 8.48217C5.41213 8.39017 5.35303 8.30737 5.27934 8.23871L2.55934 5.51871H12.2493C12.4483 5.51871 12.639 5.43969 12.7797 5.29904C12.9203 5.15839 12.9993 4.96762 12.9993 4.76871C12.9993 4.5698 12.9203 4.37903 12.7797 4.23838C12.639 4.09773 12.4483 4.01871 12.2493 4.01871H2.55934L5.27934 1.29871Z"
        fill="black"
      />
    </svg>
  );
}

export default ArrowleftIcon;
